"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUpdatePrintableLayerZIndex = exports.handleUpdateDesignForPrintables = exports.handleSwapHalfSpreads = exports.handleAddEditableTextLayerToPrintable = exports.handleValidateProductOptions = exports.handleRemoveAllImages = exports.handleMarkForDeletion = exports.handleUpdateProjectProductOptions = exports.handleUpdatePrintableDesign = exports.handlleRemoveLayersFromPrintable = exports.handleRemovePrintableFromPrintableGroup = exports.handleAddInteriorPrintablesToBookProject = exports.handleUpdatePrintableGroupQuantity = exports.handleUpdatePrintableLayerUserData = exports.handleUpdatePrintableGroupWorkspaceRotation = exports.handleUpdateProjectMarkedForDeletion = exports.handleUpdateProjectStatus = exports.handleUpdateSelectedGalleryId = exports.handleUpdateProjectName = exports.handleUpdatePrintableGroupOrder = exports.handleSwapPrintableLayerUserData = exports.handleIsDesignServicesProject = exports.handleAckEmptyPrintable = exports.handleUpdatePrintableLayerPosition = void 0;
var handleUpdatePrintableLayerPosition_1 = require("./handleUpdatePrintableLayerPosition");
Object.defineProperty(exports, "handleUpdatePrintableLayerPosition", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableLayerPosition_1).default;
  }
});
var handleAckEmptyPrintable_1 = require("./handleAckEmptyPrintable");
Object.defineProperty(exports, "handleAckEmptyPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(handleAckEmptyPrintable_1).default;
  }
});
var handleIsDesignServicesProject_1 = require("./handleIsDesignServicesProject");
Object.defineProperty(exports, "handleIsDesignServicesProject", {
  enumerable: true,
  get: function () {
    return __importDefault(handleIsDesignServicesProject_1).default;
  }
});
var handleSwapPrintableLayerUserData_1 = require("./handleSwapPrintableLayerUserData");
Object.defineProperty(exports, "handleSwapPrintableLayerUserData", {
  enumerable: true,
  get: function () {
    return __importDefault(handleSwapPrintableLayerUserData_1).default;
  }
});
var handleUpdatePrintableGroupOrder_1 = require("./handleUpdatePrintableGroupOrder");
Object.defineProperty(exports, "handleUpdatePrintableGroupOrder", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableGroupOrder_1).default;
  }
});
var handleUpdateProjectName_1 = require("./handleUpdateProjectName");
Object.defineProperty(exports, "handleUpdateProjectName", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateProjectName_1).default;
  }
});
var handleUpdateSelectedGalleryId_1 = require("./handleUpdateSelectedGalleryId");
Object.defineProperty(exports, "handleUpdateSelectedGalleryId", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateSelectedGalleryId_1).default;
  }
});
var handleUpdateProjectStatus_1 = require("./handleUpdateProjectStatus");
Object.defineProperty(exports, "handleUpdateProjectStatus", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateProjectStatus_1).default;
  }
});
var handleUpdateProjectMarkedForDeletion_1 = require("./handleUpdateProjectMarkedForDeletion");
Object.defineProperty(exports, "handleUpdateProjectMarkedForDeletion", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateProjectMarkedForDeletion_1).default;
  }
});
var handleUpdatePrintableGroupWorkspaceRotation_1 = require("./handleUpdatePrintableGroupWorkspaceRotation");
Object.defineProperty(exports, "handleUpdatePrintableGroupWorkspaceRotation", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableGroupWorkspaceRotation_1).default;
  }
});
var handleUpdatePrintableLayerUserData_1 = require("./handleUpdatePrintableLayerUserData");
Object.defineProperty(exports, "handleUpdatePrintableLayerUserData", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableLayerUserData_1).default;
  }
});
var handleUpdatePrintableGroupQuantity_1 = require("./handleUpdatePrintableGroupQuantity");
Object.defineProperty(exports, "handleUpdatePrintableGroupQuantity", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableGroupQuantity_1).default;
  }
});
var handleAddInteriorPrintablesToBookProject_1 = require("./handleAddInteriorPrintablesToBookProject");
Object.defineProperty(exports, "handleAddInteriorPrintablesToBookProject", {
  enumerable: true,
  get: function () {
    return __importDefault(handleAddInteriorPrintablesToBookProject_1).default;
  }
});
var handleRemovePrintableFromPrintableGroup_1 = require("./handleRemovePrintableFromPrintableGroup");
Object.defineProperty(exports, "handleRemovePrintableFromPrintableGroup", {
  enumerable: true,
  get: function () {
    return __importDefault(handleRemovePrintableFromPrintableGroup_1).default;
  }
});
var handleRemoveLayersFromPrintable_1 = require("./handleRemoveLayersFromPrintable");
Object.defineProperty(exports, "handlleRemoveLayersFromPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(handleRemoveLayersFromPrintable_1).default;
  }
});
var handleUpdatePrintableDesign_1 = require("./handleUpdatePrintableDesign");
Object.defineProperty(exports, "handleUpdatePrintableDesign", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableDesign_1).default;
  }
});
var handleUpdateProjectProductOptions_1 = require("./handleUpdateProjectProductOptions");
Object.defineProperty(exports, "handleUpdateProjectProductOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateProjectProductOptions_1).default;
  }
});
var handleMarkForDeletion_1 = require("./handleMarkForDeletion");
Object.defineProperty(exports, "handleMarkForDeletion", {
  enumerable: true,
  get: function () {
    return __importDefault(handleMarkForDeletion_1).default;
  }
});
var handleRemoveAllImages_1 = require("./handleRemoveAllImages");
Object.defineProperty(exports, "handleRemoveAllImages", {
  enumerable: true,
  get: function () {
    return __importDefault(handleRemoveAllImages_1).default;
  }
});
var handleValidateProductOptions_1 = require("./handleValidateProductOptions");
Object.defineProperty(exports, "handleValidateProductOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(handleValidateProductOptions_1).default;
  }
});
var handleAddEditableTextLayerToPrintable_1 = require("./handleAddEditableTextLayerToPrintable");
Object.defineProperty(exports, "handleAddEditableTextLayerToPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(handleAddEditableTextLayerToPrintable_1).default;
  }
});
var handleSwapHalfSpreads_1 = require("./handleSwapHalfSpreads");
Object.defineProperty(exports, "handleSwapHalfSpreads", {
  enumerable: true,
  get: function () {
    return __importDefault(handleSwapHalfSpreads_1).default;
  }
});
var handleUpdateDesignForPrintables_1 = require("./handleUpdateDesignForPrintables");
Object.defineProperty(exports, "handleUpdateDesignForPrintables", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdateDesignForPrintables_1).default;
  }
});
var handleUpdatePrintableLayerZIndex_1 = require("./handleUpdatePrintableLayerZIndex");
Object.defineProperty(exports, "handleUpdatePrintableLayerZIndex", {
  enumerable: true,
  get: function () {
    return __importDefault(handleUpdatePrintableLayerZIndex_1).default;
  }
});